import Parser from 'html-react-parser'
import _ from '@/utils/lodash-optimized'
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import { CLINICAL_ROLES, NON_CLINICAL_ROLES } from 'shared_src/dictionaries/roles/compassion'
import { Actions } from 'shared_src/igao/actions'
import { Issues } from 'shared_src/igao/issues'

import { AbilityContext } from '../../../../ability/context'
import { Action, Permission } from '../../../../ability/types'
import { IssuePriorities } from '../../../../lib/Codes'
import Statuses from '../../../../lib/Codes/ActionStatuses'
import Trends from '../../../../lib/Codes/Trends'
import { uid } from '../../../igao/utils'
import {
  bindTargetMixin,
  PractitionerSelectInput,
  SelectInput,
  Fieldset,
  TextAreaInput,
  CancelButton,
  SaveButton,
  FormDebugger,
  IGAOActionsAutocompleteField as AutoComplete,
  removeBlanks
} from '../../../shared/FormBuilder'
import { Badge, FlatButton, Button } from '../../../shared/NarusMaterial'

import ActionForm from './ActionForm'
import { ActionStatusModal } from './ActionStatusModal'
import { AddActionDescription } from './AddAction'
import { Comment, pullCommentsFromIssue } from './Comment'
import IssueFilters from './IssueFilters'

import './styles.scss'

class IssueForm_ extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.state = {
      initialValue: props.value,
      initialStatus: props.value.status,
      value: { ...props.value },
      actionStatusModalOpen: false,
      actionFilters: [ 'in-progress', 'not-started' ],
      actionCounts: {},
      actionIdsCheckedComplete: [],
      actionModalActionIds: [],
      issueToBeSaved: {},
      needReassign: false
    }
    this.handleCancelStatusModal = this.handleCancelStatusModal.bind(this)
    this.addId = this.addId.bind(this)
    this.setActionStatusFilters = this.setActionStatusFilters.bind(this)
    this.getActionCounts = this.getActionCounts.bind(this)
    this.actionsList = this.actionsList.bind(this)
    this.setOtherAction = this.setOtherAction.bind(this)
    this.addOtherActionToForm = this.addOtherActionToForm.bind(this)
    this.handleFormSave = this.handleFormSave.bind(this)
    this.handlePractitionerSelect = this.handlePractitionerSelect.bind(
      this
    )
  }

  /**
   * On submit handler
   */
  handleSubmit () {
    return this.props.onSubmit && this.props.onSubmit(this.getValue())
  }

  /**
   * This function formats the issue form data on handleSubmit.
   *
   * @param {Null} null.
   * @returns {Object} issue. Issue form data.
   */
  getValue () {
    const issue = { ...this.state.value }
    issue.actions = issue.actions || []

    return issue
  }

  handlePractitionerSelect (value) {
    this.setInputValue('.assignee', value)
    if (value && _.isEqual(value.id, this.props.currentUser.id)) {
      this.setInputValue('.status', 'in-progress')
    } else {
      this.setInputValue('.status', 'not-started')
    }
  }

  getActionCounts () {
    const {
      value: { actions }
    } = this.state
    return _.reduce(
      actions,
      (counters, action) => {
          const status = action?.status
        if (_.has(counters, status)) {
          counters[status]++
        } else {
          counters[status] = 1
        }
        return counters
      }, {}
    )
  }

  renderActionsBadge (type, count) {
    const titles = {
      suggested: 'Suggested',
      optional: 'Optional'
    }

    const isActive = this.state.openedActions === type

    return (
      <div className='col-xs-3'>
        <Badge
          color='grey'
          count={count}
          title={titles[type]}
          onClick={() =>
            (isActive
              ? this.setState({ openedActions: null })
              : this.setState({ openedActions: type }))}
          style={isActive ? { color: '#2F7DE1' } : {}}
        />
      </div>
    )
  }

  addAction (action, completed, otherAction) {
    const dueDays = action?.dueDays
    const extendedAction = {
      ...action,
      start: moment(),
      dueDate: (dueDays
        ? moment()
          .add(dueDays, 'd')
        : moment()
          .add(1, 'd')
      )
        .format('MM/DD/YYYY'),
      status: completed ? 'completed' : 'not-started',
      actionId: uid()
    }
    this.setState(state => ({
      ...state,
      otherAction: otherAction ? null : state.otherAction,
      value: {
        ...state.value,
        actions: [ ...state.value.actions, extendedAction ]
      }
    }))
  }

  setOtherAction (otherAction, cb) {
    this.setState({
      otherAction
    },
    cb)
  }

  addOtherActionToForm () {
    this.addAction(this.state.otherAction, false, true)
  }

  actionsList () {
    const selectedActions = this.state.value.actions
      .filter(a => a.id)
      .map(v => v.id)
    return _.filter(Actions, a => selectedActions.indexOf(a.id) === -1)
  }

  renderAvailableActions (actions) {
    const notAddedActions = actions.filter(
      a =>
        !(this.state.value.actions || [])
          .find(
            existingA => existingA.id === a.id
          )
    )

    return (
      <div className='add-actions-list collection-input igao-actions'>
        {notAddedActions.map(action => {
          const completed = this.state.actionIdsCheckedComplete.includes(
            action.id
          )
          return (
            <AddActionDescription
              key={action.id}
              description={action.description}
              dueDays={action.dueDays}
              onAdd={() => this.addAction(action, completed)}
              mandatory={action.mandatory}
              easyComplete
              isCompleted={completed}
              onComplete={() => this.handleEasyActionComplete(action.id)}
            />
          )
        })}
      </div>
    )
  }

  handleEasyActionComplete (actionId) {
    const { actionIdsCheckedComplete } = this.state
    let newIds = actionIdsCheckedComplete
    if (actionIdsCheckedComplete.includes(actionId)) {
      newIds = _.remove(actionIdsCheckedComplete, a => {
        if (a !== actionId) {
          return a
        }
      })
    } else {
      newIds.push(actionId)
    }
    this.setState({
      actionIdsCheckedComplete: newIds
    })
  }

  addId (id, changeToComplete, defaultStatus) {
    const { issueToBeSaved } = this.state
    const newStatus = changeToComplete ? 'completed' : defaultStatus
    const newActions = issueToBeSaved.actions.map(a => {
      if (id === a.id) {
        return {
          ...a,
          status: newStatus
        }
      }
      return a
    })
    this.setState({
      issueToBeSaved: {
        ...issueToBeSaved,
        actions: newActions
      }
    })
  }

  handleFormSave () {
    const { value, initialStatus } = this.state

    const currentStatusCheck =
      value.status === 'completed' ||
      value.status === 'on-hold' ||
      value.status === 'deferred' ||
      value.status === 'cancelled'

    const initialStatusCheck =
      initialStatus === 'not-started' || initialStatus === 'in-progress'

    const hasAgentActions = this.state.value.actions.some(a => {
      const assigneeId = a.assignee?.id
      if (!assigneeId) {
        return false
      }
      const assignee = this.props.practitioners.find(p => p.id === assigneeId)
      return [ 'broker_access', 'csr_agent' ].includes(assignee?.role?.[0]?.code?.text)
    })

    const assigneeId = this.state.value.assignee?.id
    const assignee = assigneeId ? this.props.practitioners.find(p => p.id === assigneeId) : null
    const isClinicalAssignee = !assigneeId ? false : CLINICAL_ROLES.includes(assignee?.role?.[0]?.code?.text)
    const isNonClinicalIssue = this.state.value.nonClinicalIssue

    const blockCreate = hasAgentActions && isClinicalAssignee && isNonClinicalIssue

    if (blockCreate) {
      this.setState({
        needReassign: true
      })
      return
    }

    if (currentStatusCheck && initialStatusCheck && value.actions.length) {
      const issueToBeSaved = Object.assign(value)
      const newActions = issueToBeSaved.actions.map((a, index) => {
        if (a.id === 'FREETEXT') {
          return {
            ...a,
            id: `FREETEXT${index}`
          }
        }
        return a
      })
      this.setState({
        actionStatusModalOpen: true,
        issueToBeSaved: {
          ...issueToBeSaved,
          actions: newActions
        }
      })
    } else {
      this.props.onSubmit(this.getValue())
    }
  }

  setNewActionStatus (defaultValue) {
    const { currentUser } = this.props
    const { issueToBeSaved } = this.state

    const newActions = issueToBeSaved.actions.map(a => {
      if (a.status !== defaultValue && a.status !== 'completed') {
        return {
          ...a,
          status: defaultValue,
          assignee: {
            id: currentUser.id,
            display: currentUser.display
          }
        }
      }
      return {
        ...a,
        assignee: {
          id: currentUser.id,
          display: currentUser.display
        }
      }
    })
    return {
      ...issueToBeSaved,
      actions: newActions
    }
  }

  defaultActionStatusValidation () {
    const { status } = this.getValue()
    if (
      status === 'cancelled' ||
      status === 'completed' ||
      status === 'on-hold'
    ) {
      return 'cancelled'
    }
    if (status === 'deferred') {
      return 'deferred'
    }
  }

  closeActionStatusModal () {
    this.setState({
      actionStatusModalOpen: false
    })
  }

  handleCancelStatusModal () {
    this.setState({
      actionStatusModalOpen: false,
      issueToBeSaved: {}
    })
  }

  renderActionStatusModal () {
    const { issueToBeSaved } = this.state

    const defaultStatus = this.defaultActionStatusValidation()

    const actions = [
      <Button
        key={1}
        label='Cancel'
        grey
        onClick={this.handleCancelStatusModal}
      />,
      <Button
        key={2}
        label='Save Issue'
        onClick={() => {
          this.props.onSubmit(this.setNewActionStatus(defaultStatus))
          this.closeActionStatusModal()
        }}
      />
    ]

    return (
      <ActionStatusModal
        onIdAdd={this.addId}
        actions={actions}
        issue={issueToBeSaved}
        defaultStatus={defaultStatus}
      />
    )
  }

  setActionStatusFilters (filter) {
    const { actionFilters } = this.state
    const newFilters = actionFilters
    if (newFilters.includes(filter)) {
      _.pull(newFilters, filter)
    } else {
      newFilters.push(filter)
    }
    this.setState({
      actionFilters: newFilters
    })
  }

  validateFormStatus () {
    const {
      value: { status, comments },
      initialValue
    } = this.state
    if (_.isEqual(removeBlanks(this.state.value), removeBlanks(
      initialValue
    ))) {
      return true
    }
    if (status && status === 'cancelled' && !comments) {
      return true
    }
    return false
  }

  removeAction (idx) {
    this.setState(s => {
      const updatedActions = [ ...s.value.actions ]
      updatedActions.splice(idx, 1)

      return {
        ...s,
        value: {
          ...s.value,
          actions: updatedActions
        }
      }
    })
  }

  render () {
    const { value } = this.state
    const { currentUser } = this.props
    const issueTemplate = Issues[this.state.value.issueTemplateId]
    const allActions = issueTemplate?.actions || []

    const selectedActions = _.compact(
      this.state.value.actions.map(a => a.id)
    )
    const suggestedActions = _.sortBy(
      _.filter(
        allActions,
        a => a.mandatory && selectedActions.indexOf(a.id) === -1
      ),
      [ 'type', 'description' ]
    )

    const optionalActions = _.sortBy(
      _.filter(
        allActions,
        a => !a.mandatory && !a.other && selectedActions.indexOf(a
          .id) === -1
      ),
      [ 'type', 'description' ]
    )

    const statuses = Statuses.all
    const canReadClinical = this.context.can(Action.READ, Permission.IGAO_CLINICAL)
    const allowedRoles = canReadClinical
      ? undefined
      : NON_CLINICAL_ROLES

    return (
      <div className='issue-form'>
        {this.state.actionStatusModalOpen
          ? this.renderActionStatusModal()
          : null}
        <div className='form'>
          <div className='row bottom-xs'>
            <div className='col-xs-12 col-sm-12'>
              <h1>{Parser(value.description || '', { trim: true })}</h1>
            </div>

            <div className='col-xs-12 col-sm-12'>
              <h3 className='subheader'>
                Goal:
                {' '}
                {issueTemplate?.goal?.description || value.goal}
              </h3>
            </div>

            <div className='col-xs-12 col-sm-6'>
              <PractitionerSelectInput
                name='assignee'
                label='Assignee'
                onChange={this.handlePractitionerSelect}
                filterFn={items => items.filter(item => {
                  if (!allowedRoles) {
                    return true
                  }
                  return allowedRoles.includes(item.role?.[0]?.code.text)
                })}
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <SelectInput
                label='Status'
                name='status'
                noSort
                options={statuses}
                required
                disabled={
                  (this.state.value.assignee &&
                    this.state.value.assignee?.id) !== this.props.currentUser?.id
                }
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <SelectInput
                label='Patient Priority'
                name='priority'
                noSort
                options={IssuePriorities}
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <SelectInput
                options={Trends}
                label='Trend'
                name='trend'
              />
            </div>

            <div className='col-xs-12'>
              <TextAreaInput
                required={this.state.value.status === 'cancelled'}
                name='comment'
                label='Comment'
              />
            </div>
          </div>

          <h1>Actions</h1>
          <IssueFilters
            onChange={this.setActionStatusFilters}
            activeFilters={this.state.actionFilters}
            counts={this.getActionCounts()}
          />

          <Fieldset name='actions'>
            {this.state.value.actions.map((action, idx) => {
              if (
                action.status === null ||
                this.state.actionFilters.includes(action.status)
              ) {
                return (
                  <div
                    className='row xs-between'
                    style={{ width: '100%' }}
                    key={idx}
                  >
                    <div className='col-xs-10'>
                      <ActionForm
                        currentUser={currentUser}
                        name={idx}
                        nonClinicalIssue={value.nonClinicalIssue}
                      />
                    </div>
                    {!action.isExisting
                      ? (
                        <div className='col-xs-2'>
                          <button
                            style={{ width: '100%' }}
                            className='remove-btn icon icon-circle-subtract'
                            onClick={() => this.removeAction(idx)}
                          />
                        </div>
                      )
                      : null}
                  </div>
                )
              }
              return null
            })}
          </Fieldset>

          <h1>Add Action</h1>

          <div className='other-action-add row between-xs'>
            <div className='col-xs-10 action-input'>
              <AutoComplete
                list={this.actionsList()}
                name='otherAction'
                value={this.state.otherAction || null}
                label='Search for action or create a new one'
                onChange={this.setOtherAction}
                onSubmit={this.addOtherActionToForm}
                freetext
              />
            </div>
            <div className='col-xs-2 action-btn'>
              <FlatButton
                disabled={!this.state.otherAction}
                label='ADD'
                onClick={this.addOtherActionToForm}
              />
            </div>
          </div>

          <div className='row'>
            {this.renderActionsBadge('suggested', suggestedActions.length)}
            {this.renderActionsBadge('optional', optionalActions.length)}
          </div>

          {this.renderAvailableActions(
            (this.state.openedActions === 'suggested' && suggestedActions) ||
              (this.state.openedActions === 'optional' && optionalActions) ||
              []
          )}

          {false && (
            <div
              className='row'
              style={{ clear: 'both' }}
            >
              <FormDebugger state={this.state} />
            </div>
          )}
        </div>
        <div className='comments'>
          {pullCommentsFromIssue(this.state.value).map((c, index) => (
            <Comment
              key={index}
              {...c}
            />
          ))}
        </div>
        <div
          className='row end-xs margin-top modal-actions'
          style={{ margin: '20px 15px 0px 0px' }}
        >
          {this.state.needReassign && (
            <div className='reassign-warning'>
              <div>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  role='presentation'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z'
                    fill='currentColor'
                  />
                </svg>
              </div>
              <div className='text-block'>
                <h3 className='title'>
                  Action Required Before Reassignment
                </h3>
                <p className='description'>
                  This issue cannot be transferred from a non-clinical to a clinical category because there are pending actions assigned to users in Broker Access or CSR Agent roles. Please reassign all such actions to the appropriate users or resolve them before proceeding with the reassignment.
                </p>
              </div>
            </div>)}
          <CancelButton
            formKey={this.props.formKey}
            onClick={this.props.onCancel}
          />
          <SaveButton
            formKey={this.props.formKey}
            ignoreGlobalDisable
            disabled={this.state.errors || this.validateFormStatus()}
            onClick={this.handleFormSave}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  practitioners: redux.users.practitioners
})

const IssueForm = connect(mapStateToProps)(
  IssueForm_
)

export default IssueForm

IssueForm_.contextType = AbilityContext
